export const isValidEmail = (email) => {
  const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@.]+$/;
  return regexEmail.test(email);
};
